define('constants/liveReceptionistScriptConstants',[], function() {
    return {
        status: {
            pending: {
                id: 0,
                name: "Pending"
            },
            active: {
                id: 1,
                name: "Active"
            },
            deactivated: {
                id: 2,
                name: "Deactivated"
            }
        }
    };
});
